import { Box } from "@mui/material";
import { ReactComponent as CloseIcon } from "../assets/images/close.svg";
import {
  StepRoot,
  CloseRow,
  CloseButton,
  StepBody,
  StepTitle,
  StepSubtitle,
  PrimaryButton,
  LinkButton,
  ButtonRow,
  DigitField,
} from "./ForgottenPasswordStyles";

// Visual order is fifth → first to read correctly in RTL.
const DIGIT_ORDER = ["fifth", "fourth", "third", "second", "first"];

const ForgottenPasswordTokenStep = ({ close, handleSendToken, handleVerifyToken, digits, setDigits }) => {
  const setDigit = (key) => (e) =>
    setDigits((prv) => ({ ...prv, [key]: e.target.value }));

  const allFilled =
    digits.first && digits.second && digits.third && digits.fourth && digits.fifth;

  return (
    <StepRoot>
      <CloseRow>
        <CloseButton onClick={close}>
          <CloseIcon />
        </CloseButton>
      </CloseRow>

      <StepBody>
        <StepTitle>קוד אימות</StepTitle>
        <StepSubtitle>
          העתק את הקוד שקיבלת במייל כדי לאמת שחזור חשבון זה
        </StepSubtitle>

        <Box sx={{ display: "flex", justifyContent: "center", gap: "12px", mb: "8px" }}>
          {DIGIT_ORDER.map((key) => (
            <DigitField
              key={key}
              inputProps={{ maxLength: 1 }}
              onChange={setDigit(key)}
              value={digits[key] || ""}
              type="text"
            />
          ))}
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", mb: "16px" }}>
          <LinkButton onClick={handleSendToken} variant="text">
            לא קבלתי, שלח קוד נוסף
          </LinkButton>
        </Box>

        <ButtonRow>
          <PrimaryButton
            onClick={handleVerifyToken}
            disabled={!allFilled}
            variant="contained"
          >
            אישור
          </PrimaryButton>
        </ButtonRow>
      </StepBody>
    </StepRoot>
  );
};

export default ForgottenPasswordTokenStep;
